import OurLogo from './helpers/OurLogo.js';

export default {
  name: `AppLogin`,
  components: {
    OurLogo    
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    fetchDashboard () {

    }
  },
  mounted () {
    console.log('applogin')
  },
  template: `
  <div class="login-layout">
    <div class="main-container">
      <router-view></router-view>
    </div>
    <div class="footer-container">
      <footer class="footer">
      
      </footer>
    </div>
  </div>
  `,
};